import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { REVOLVING_PURCHASE, REVOLVING_QUERY, REVOLVING_REFUNDS } from '@app/@core/constants/routes.constants';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { RevolvingGuard } from './revolving.guard';

const routes: Routes = [
  {
    path: REVOLVING_PURCHASE,
    loadChildren: () => import('./purchases/purchases.module').then((m) => m.PurchasesModule),
    data: { title: marker('sidenav.menu.revolving.purchases') },
    canActivate: [RevolvingGuard],
  },
  {
    path: REVOLVING_REFUNDS,
    loadChildren: () => import('./refunds/refunds.module').then((m) => m.RefundsModule),
    data: { title: marker('sidenav.menu.revolving.refunds') },
    canActivate: [RevolvingGuard],
  },
  {
    path: REVOLVING_QUERY,
    loadChildren: () => import('./queries/queries.module').then((m) => m.QueriesModule),
    data: { title: marker('sidenav.menu.revolving.queries') },
    canActivate: [RevolvingGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RevolvingRoutingModule {}
